var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useContext, useRef } from "react";
import { styled, Tooltip } from "@mui/material";
import { ConfirmContext } from "../Confirm";
import { EditContext } from "./EditableTable";
import { grey } from "@mui/material/colors";
import { jsx as _jsx } from "react/jsx-runtime";
const Button = styled("div")(props => ({ cursor: "pointer", borderRadius: "50%", width: "1rem", color: props.disabled ? grey["500"] : grey["700"], display: "flex", justifyContent: "center", alignItems: "center", "& svg.MuiSvgIcon-root": { fontSize: "1rem" }, "&:hover": props.disabled ? {} : { backgroundColor: "hsla(0,0%,0%,0.1)" } }));
export function SimpleIconButton(props) { const { confirm, tooltip, disabled, onClick } = props, otherProps = __rest(props, ["confirm", "tooltip", "disabled", "onClick"]); const dblClickActiveRef = useRef(false); const confirmCtx = useContext(ConfirmContext); const editCtx = useContext(EditContext); const btn = /*#__PURE__*/ _jsx(Button, Object.assign({ disabled: !!props.disabled, onClick: (e) => __awaiter(this, void 0, void 0, function* () { if (props.disabled)
        return; if (props.confirm) {
        yield confirmCtx.confirm(props.confirm);
    } if (props.onClick) {
        if (dblClickActiveRef.current)
            return;
        dblClickActiveRef.current = true;
        const rs = props.onClick({ event: e, editCtx: editCtx });
        if (rs instanceof Promise) {
            try {
                yield rs;
            }
            catch (e) { }
        }
        dblClickActiveRef.current = false;
    } }) }, otherProps)); if (props.tooltip) {
    return /*#__PURE__*/ _jsx(Tooltip, { title: props.tooltip, children: btn });
} return btn; }
